export default __webpack_public_path__ + "static/media/back_icon.53b4b2b1.svg";